const getSuggestions = (value) => {
  return {
    query: `{entitySuggestions: entities (suggestions: "${value}") {name}}`
  }
};

const getRecommendations = (searchTerms) => {
  return {
    query: `{entityRecommendations: entities (recommendations: "${searchTerms}") {name}}`
  }
}

const getEntitiesWebPages = (searchTerms) => {
  return {
    query: `{entitiesWebPages: webPages (entities: "${searchTerms}") {id, title, remoteId}}`
  };
}

const getMutationCreateClassifier = (classifierName, entityQuery) => {
  return {
    query: `mutation {
      savedNewClassifier: createEntity (name: "${classifierName}", query: "${entityQuery}") {
        classifier: entity { name }
      }
    }`
  };
}

export default {
  getSuggestions,
  getRecommendations,
  getEntitiesWebPages,
  getMutationCreateClassifier
};



// WEBPACK FOOTER //
// ./src/components/entityRecommender/entityRecommender.query.jsx